import PropTypes from 'prop-types'
import React from 'react'
import data from '../data/projects.json'
import me from '../images/me_pizza.jpg'
class Main extends React.Component {
  render() {
    let close = (
      <div
        className="close"
        onClick={() => {
          this.props.onCloseArticle()
        }}
      />
    )
    return (
      <div
        ref={this.props.setWrapperRef}
        id="main"
        style={this.props.timeout ? { display: 'flex' } : { display: 'none' }}
      >
        <article
          id="work"
          className={`${this.props.article === 'work' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <div>
            {data.Projects.map((projects, i) => {
              return (
                <div key={i}>
                  <h1>{projects.title}</h1>
                  <p
                    className="skills"
                    dangerouslySetInnerHTML={{ __html: projects.tech }}
                  />
                  <button
                    onClick={() => {
                      let url = projects.url
                      window.location.replace(url)
                    }}
                  >
                    Visit Site
                  </button>
                  <hr />
                </div>
              )
            })}
          </div>
          {close}
        </article>

        <article
          id="about"
          className={`${this.props.article === 'about' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <div className="about_struc">
            <span className="image main">
              <img src={me} alt="" />
            </span>
            <p>
              Hello, my name is Dalton Carr. I currently reside in Portland, OR,
              where I work as a Front End Engineer for Orbis Systems. I truly
              enjoy working in Fin-tech and also am involved heavily in the Web3
              community. I love building beautiful and unique web experiences
              using the most up to date technologies. On my free time I love to
              paint and create digital art as well. You'll find me on the slopes
              during the winter, snowboarding most weekends and mountain biking
              during the summer. Oh, and I love pizza.
            </p>
            <p />
          </div>
          {close}
        </article>
      </div>
    )
  }
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
